import { ReadonlyVec2 } from 'gl-matrix';
import { gl } from '../../../Engine';

export class UniformVec2Array {
    protected readonly name: string;

    constructor(name: string) {
        this.name = name;
    }

    public loadVectors(programID: WebGLProgram, vectors: ReadonlyVec2[]) {
        let index = 0;
        let location: WebGLUniformLocation | null;
        for (const v of vectors) {
            const name = `${this.name}[${index++}]`;
            location = gl.getUniformLocation(programID, name);
            if (!location) {
                console.debug(vectors);
                throw new Error(
                    "Attempted to load uniform location '" +
                        name +
                        "' that does not exist."
                );
            } else {
                gl.uniform2fv(location, v);
            }
        }
    }
}
